export const passwordMessages = {
  error: {
    password: {
      id: 'passwordValidation.Error.Password',
      defaultMessage: 'Password does not meet security requirements.',
    },
    confirmPassword: {
      id: 'passwordValidation.Error.ConfirmPassword',
      defaultMessage: 'Passwords do not match.',
    },
  },
};
